import chatThreadIcon from "@/assets/figma/card-menu/chat-thread.svg";
import { cn } from "@/shared/lib/cn";
import { MerryChatLabel } from "@/shared/ui/MerryChatLabel";
import type { MerryChatActivityItem } from "@/shared/ui/merryChatActivityModel";

export interface MerryChatThreadSummaryProps {
  className?: string;
  iconSource?: string;
  item: MerryChatActivityItem;
}

export function MerryChatThreadSummary({
  className,
  iconSource = chatThreadIcon,
  item,
}: MerryChatThreadSummaryProps) {
  return (
    <span className={cn("merry-chat-thread-summary", className)}>
      <span className="merry-chat-thread-summary__title">
        <img alt="" aria-hidden="true" src={iconSource} />
        <strong>{item.title}</strong>
      </span>
      <span className="merry-chat-thread-summary__meta">
        <span>{item.preview}</span>
        {item.time ? <time>{item.time}</time> : null}
        <MerryChatLabel size={14} type={item.status} />
      </span>
    </span>
  );
}
